module.exports = __webpack_public_path__ + "img/gallery03.20b301bc.jpg";